<template>
<v-container id="dashboard" fluid tag="section" v-if="ver">
    <v-row v-if="anio_recuperacion!=''">
        <v-col>
            <span style="font-size:15px;"><strong>Año de recuperación desde: {{anio_recuperacion}}</strong></span>
        </v-col>
    </v-row>
    <v-row>

        <!-- CUADRO 2 - RECUPERACION DIARIA -->
        <v-col cols="12" sm="6" :lg="expediente?3:4">
            <base-material-stats-card id="2" :key="'B'+pedimentosB+ remesasB" :selected="selected==2" color="green darken-4" subTextColor="green darken-4" icon="mdi-clock-outline" title="Pedimentos " :value="pedimentosB" subtitle="Remesas" :smallValue="remesasB" subColor="black--text" sub-icon="mdi-clock-outline" sub-text="Recuperación Diaria" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'MES ' +mesB" :onClickBtn1="cambiarMesB" />
        </v-col>
        <v-dialog v-model="dialogB1" max-width="300px">
            <v-card>
                <v-card-text>
                    <h5>Recuperación Diaria</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el Mes</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-row no-gutters dense>
                            <v-col>
                                <v-menu offset-x ref="menuB" v-model="menuB" :close-on-content-click="false" transition="scale-transition" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field clearable v-on="on" v-model="mesB" label="Mes" color="secondary" prepend-icon="event"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="mesB" color="secondary" scrollable locale="es-mx" @input="menuB = false" type="month">
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menuB = false">
                                            Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogB1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; estadisticaConsultaB();">Consultar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- CUADRO 3 - REVISION -->
        <v-col cols="12" sm="6" :lg="expediente?3:4">
            <base-material-stats-card id="3" :key="'C'+ impoC+ expoC" :selected="selected==3" color="amber accent-4" subTextColor="amber accent-4" icon="mdi-file-search-outline" title="Importaciones" :value="impoC" :smallValue="expoC" subtitle="Exportaciones" subColor="black--text" sub-icon="mdi-file-search-outline" sub-text="Reconocimiento Aduanero" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'MES ' +mesC" :onClickBtn1="cambiarMesC" />
        </v-col>
        <v-dialog v-model="dialogC1" max-width="300px">
            <v-card>
                <v-card-text>
                    <h5>Pedimentos en Revisión</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el Mes</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-row no-gutters dense>
                            <v-col>
                                <v-menu offset-x ref="menuB" v-model="menuC" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field clearable v-on="on" v-model="mesC" label="Mes" color="secondary" prepend-icon="event"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="mesC" color="secondary" scrollable locale="es-mx" @input="menuC = false" type="month">
                                        <v-spacer />

                                        <v-btn @click="menuC = false">
                                            Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogC1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; estadisticaConsultaC();">Consultar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- CUADRO 4 - ALERTAS -->
        <v-col cols="12" sm="6" :lg="expediente?3:4">
            <base-material-stats-card id="4" :key="'D'+ impoD+ expoD" :selected="selected==4" color="red" subTextColor="red" icon="mdi-alert" title="IMPORTACIONES" :value="impoD" :smallValue="expoD" sub-icon="mdi-alert-box" sub-icon-color="green" subtitle="Exportaciones" sub-text="Alertas de Reconocimiento" subColor="black--text" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'AÑO ' +mesD" :onClickBtn1="cambiarMesD" />
        </v-col>
        <v-dialog v-model="dialogD1" max-width="300px">
            <v-card>
                <v-card-text>
                    <h5>Alertas de Reconocimiento</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el Año</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-row no-gutters dense>
                            <v-col>
                                <v-select :items="anios" :menu-props="{ top: true, offsetY: true }" label="Seleccionar el Año" v-model="mesD"></v-select>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogD1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; estadisticaConsultaD();">Consultar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- CUADRO 1 - BANDEJA -->
        <v-col v-if="expediente" cols="12" sm="6" lg="3">

            <base-material-stats-card :key="'B'+correctos+ incorrectos"  v-if="expediente" id="1" :selected="selected==1" color="indigo" subTextColor="indigo" icon="mdi-email" title="Mensajes Recibidos" :value="correctos" subtitle="Rechazados" :smallValue="incorrectos"  sub-icon="mdi-mail" sub-text="Bandeja de Expediente Electrónico" iconBtn1="mdi-calendar" :titleBtn1="'PERIODO: ' + fechaA_de + ' - ' + fechaA_a" :onClickBtn1="openDialog" :onClickBtnLink="selectItem" />

        </v-col>
    </v-row>
    <v-dialog v-model="dialogA2" max-width="600px">
                        <v-card>

                            <v-card-text>
                                <h5>Bandeja de Expediente Electrónico</h5>
                                <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                                <v-container grid-list-md text-xs-center>
                                    <v-form ref="form1" v-model="valid" lazy-validation>
                                        <v-row no-gutters dense>
                                            <v-col>
                                                <v-menu offset-x ref="menuA1" v-model="menuA1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field clearable v-on="on" v-model="fechaA_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaA_de = parseDate(fechaA_de)" v-mask="'####-##-##'" :rules="[validaMes(fechaA_de, fechaA_a), validaFechas(fechaA_de, fechaA_a)]"></v-text-field>
                                                    </template>

                                                    <v-date-picker v-model="fechaA_de" color="secondary" scrollable locale="es-mx" @input="menuA1 = false">
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menuA1 = false">
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-col>
                                                <v-menu offset-x ref="menuA2" v-model="menuA2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field clearable v-on="on" v-model="fechaA_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaA_a= parseDate(fechaA_a)" v-mask="'####-##-##'" :rules="[validaMes(fechaA_de, fechaA_a), validaFechas(fechaA_de, fechaA_a)]"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="fechaA_a" color="secondary" scrollable locale="es-mx" @input="menuA2 = false">
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menuA2 = false">
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>

                                        </v-row>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>

                                <v-spacer></v-spacer>
                                <v-btn small @click="dialogA2 = false">Cancelar</v-btn>
                                <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaA();">Consultar</v-btn>

                            </v-card-actions>
                        </v-card>
                    </v-dialog>
    <v-row>

        <v-col cols="12" lg="12" style="padding-top:5px; padding-bottom:0px; margin-top:-40px;">

            <!-- TABLA 1 - MODAL MENSAJES DE CORREO -->
            <v-card v-if="selected==1 && expediente">
                <v-card class="pa-2 indigo white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE CORREOS EN BANDEJA DE EXPEDIENTE ELECTRÓNICO
                </v-card>
                <v-card-text style="margin-top:0px;">

                    <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">
                        <v-spacer></v-spacer>
                        <span class="overline secondary--text font-weight-light ">PERIODO: {{fechaA_de}} - {{fechaA_a}}
                            <v-btn light icon title="Seleccionar Periodo" @click="dialogA2 = !dialogA2" v-tippy>
                                <v-icon small color="secondary">mdi-calendar</v-icon>
                            </v-btn>

                        </span>
                        <exportar-excel :data="data_tableA" :exportFields="data_tableA_excel" name="Correos_Recibidos.xlsx">
                            <v-btn light color="green" icon title="Descargar Información" v-tippy>
                                <v-icon dark>mdi-table</v-icon>
                            </v-btn>
                        </exportar-excel>

                    </div>
                    <v-client-table style="margin-top:0px;" ref="vuetableA" :data="data_tableA" :columns="columns_tableA" :options="tableA_options" class="elevation-2 pa-2">
                        <template slot="noResults">
                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                        </template>

                        <template slot="mensaje" slot-scope="props">
                            <v-tooltip v-if="props.row.mensaje!=''" bottom>
                                <template v-slot:activator="{ on }">
                                    <span style="color:blue;" v-on="on">Ver Mensaje</span>
                                </template>
                                <span style="font-size:9px !important;">{{ props.row.mensaje }}</span>
                            </v-tooltip>
                        </template>
                    </v-client-table>

                </v-card-text>
            </v-card>

            <!-- TABLA 2 - RECUPERACION DIARIA -->
            <v-card v-if="selected==2 ">
                <v-card class="pa-2 green darken-4 white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE PEDIMENTOS EN RECUPERACIÓN DIARIA
                </v-card>

                <v-dialog v-model="dialogB2" max-width="600px">
                    <v-card>

                        <v-card-text>
                            <h5>Pedimentos Recuperación Diaria</h5>
                            <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form2" v-model="valid" lazy-validation>
                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuB1" v-model="menuB1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaB_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaB_de = parseDate(fechaB_de)" v-mask="'####-##-##'" :rules="[validaMes(fechaB_de, fechaB_a), validaFechas(fechaB_de, fechaB_a)]"></v-text-field>
                                                </template>

                                                <v-date-picker v-model="fechaB_de" color="secondary" scrollable locale="es-mx" @input="menuB1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuB1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuB2" v-model="menuB2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaB_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaB_a= parseDate(fechaB_a)" v-mask="'####-##-##'" :rules="[validaMes(fechaB_de, fechaB_a), validaFechas(fechaB_de, fechaB_a)]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="fechaB_a" color="secondary" scrollable locale="es-mx" @input="menuB2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuB2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialogB2 = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaB();">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">
                    <v-spacer />
                    <span class="overline secondary--text font-weight-light "> PERIODO: {{fechaB_de}} - {{fechaB_a}}
                        <v-btn light icon title="Seleccionar Periodo" @click="dialogB2 = !dialogA2" v-tippy>
                            <v-icon small color="secondary">mdi-calendar</v-icon>
                        </v-btn>
                    </span>

                    <exportar-excel :data="data_tableB" :exportFields="data_tableB_excel" name="Recuperacion_Diaria.xlsx">
                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                </div>
                <v-client-table ref="vuetableB" :data="data_tableB" :columns="columns_tableB" :options="tableB_options" class="elevation-2 pa-2">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                    <template slot="search">
                        <v-alert icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                </v-client-table>

            </v-card>

            <!-- TABLA 3 - EN REVISION -->
            <v-card v-if="selected==3">
                <v-card class="pa-2 amber accent-4 white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE PEDIMENTOS EN RECONOCIMIENTO ADUANERO
                </v-card>

                <v-dialog v-model="dialogC2" max-width="600px">
                    <v-card>

                        <v-card-text>
                            <h5>Pedimentos en Revisión</h5>
                            <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form3" v-model="valid" lazy-validation>
                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuC1" v-model="menuC1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaC_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaC_de = parseDate(fechaC_de)" v-mask="'####-##-##'" :rules="[validaMes(fechaC_de, fechaC_a), validaFechas(fechaC_de, fechaC_a)]"></v-text-field>
                                                </template>

                                                <v-date-picker v-model="fechaC_de" color="secondary" scrollable locale="es-mx" @input="menuC1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuA1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuC2" v-model="menuC2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaC_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaC_a= parseDate(fechaC_a)" v-mask="'####-##-##'" :rules="[validaMes(fechaC_de, fechaC_a), validaFechas(fechaC_de, fechaC_a)]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="fechaC_a" color="secondary" scrollable locale="es-mx" @input="menuC2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuC2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialogC2 = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaC();">Consultar</v-btn>

                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">
                    <v-spacer />
                    <span class="overline secondary--text font-weight-light "> {{fechaC_de}} - {{fechaC_a}}
                        <v-btn light icon title="Seleccionar Periodo" @click="dialogC2 = !dialogC2" v-tippy>
                            <v-icon small color="secondary">mdi-calendar</v-icon>
                        </v-btn>
                    </span>

                    <exportar-excel :data="data_tableC" :exportFields="data_tableC_excel" name="ReconocimientoAduanero.xlsx">
                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>

                </div>
                <v-client-table ref="vuetableC" :data="data_tableC" :columns="columns_tableC" :options="tableC_options" class="elevation-2 pa-2">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>

                </v-client-table>

            </v-card>

            <!-- TABLA 4 - ALERTAS -->
            <v-card v-if="selected==4">

                <v-card class="pa-2 red white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE PEDIMENTOS CON ALERTAS DE RECONOCIMIENTO
                </v-card>

                <v-dialog v-model="dialogD2" max-width="600px">
                    <v-card>

                        <v-card-text>
                            <h5>Pedimentos con Alerta en Reconocimiento</h5>

                            <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form4" lazy-validation>
                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuD1" v-model="menuD1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaD_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaD_de = parseDate(fechaD_de)" v-mask="'####-##-##'" :rules="[ validaFechas(fechaD_de, fechaD_a)]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="fechaD_de" color="secondary" scrollable locale="es-mx" @input="menuD1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuD1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuD2" v-model="menuD2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaD_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaD_a= parseDate(fechaD_a)" v-mask="'####-##-##'" :rules="[ validaFechas(fechaD_de, fechaD_a)]">
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker v-model="fechaD_a" color="secondary" scrollable locale="es-mx" @input="menuD2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuD2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialogD2 = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaD();">Consultar</v-btn>

                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">

                    <v-spacer />
                    <v-switch v-model="coneliminados" color="red" style="margin-top:5px; "></v-switch>
                    <span class="overline black--text font-weight-light " style="margin-top:13px;  margin-right:80px; "> ELIMINADOS </span>

                    <span class="overline secondary--text font-weight-bold"> PERIODO: {{fechaD_de}} - {{fechaD_a}}
                        <v-btn light icon title="Seleccionar Periodo" @click="dialogD2 = !dialogD2" v-tippy>
                            <v-icon small color="secondary">mdi-calendar</v-icon>
                        </v-btn>
                    </span>

                    <exportar-excel :data="data_tableD" :exportFields="data_tableD_excel" name="AlertasReconocimiento.xlsx">
                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                </div>
                <v-client-table ref="vuetableD" :data="data_tableD" :columns="columns_tableD" :options="tableD_options" class="elevation-2 pa-2">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>

                </v-client-table>

            </v-card>

        </v-col>

    </v-row>
    <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important">
        <!-- GRAFICA 1 -->
        <v-col cols="12" lg="4" style="padding-top:0px;">
            <div ref="grafica3">
                <base-material-chart-card :options="data_grafica1" color="light-blue darken-4" type="Bar">

                    <h5 class="card-title font-weight-light mt-2 ml-2">Importaciones</h5>

                    <br />

                    <table class="table text-center">
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">PEDIMENTOS</span></td>
                            <td><span class="overline grey--text  font-weight-light">REMESAS</span></td>
                            <td><span class="overline grey--text  font-weight-light">rectificaciones</span></td>
                        </tr>
                        <tr>

                            <td><span class="overline black--text  font-weight-light">{{totalA_G1}}</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalR_G1}}</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalB_G1}}</span></td>
                        </tr>
                        <tr>

                        </tr>
                    </table>
                    <hr />
                    <div class="pl-5">
                        <v-btn class="mr-1 secondary--text" light icon title="Seleccionar Año" @click="dialog1 = !dialog1" v-tippy>
                            <v-icon>mdi-calendar</v-icon><span class="caption secondary--text  font-weight-light">Año {{a1}}</span>
                        </v-btn>

                    </div>
                </base-material-chart-card>
                <v-dialog v-model="dialog1" max-width="500px">
                    <v-card>

                        <v-card-text>
                            <h5>Importaciones y Rectificaciones</h5>
                            <v-select :items="anios" :menu-props="{ top: true, offsetY: true }" label="Seleccionar el Año" v-model="a1"></v-select>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog1 = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="estadisticaGrafica1">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>

        </v-col>

        <!-- GRAFICA 2 -->
        <v-col cols="12" lg="4" style="padding-top:0px;">
            <div ref="grafica2">
                <base-material-chart-card :options="data_grafica2" color="teal darken-4" type="Bar">

                    <h5 class="card-title font-weight-light mt-2 ml-2">Exportaciones</h5>
                    <br />

                    <table class="table text-center">
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">PEDIMENTOS</span></td>
                            <td><span class="overline grey--text  font-weight-light">REMESAS</span></td>
                            <td><span class="overline grey--text  font-weight-light">rectificaciones</span></td>
                        </tr>
                        <tr>

                            <td><span class="overline black--text  font-weight-light">{{totalA_G2}}</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalR_G2}}</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalB_G2}}</span></td>
                        </tr>
                        <tr>

                        </tr>
                    </table>

                    <hr />
                    <div class="pl-5">
                        <v-btn class="mr-1 secondary--text" light icon title="Seleccionar Año" @click="dialog2 = !dialog2" v-tippy>
                            <v-icon>mdi-calendar</v-icon><span class="caption secondary--text  font-weight-light">Año {{a2}}</span>
                        </v-btn>
                    </div>
                </base-material-chart-card>
                <v-dialog v-model="dialog2" max-width="500px">
                    <v-card>

                        <v-card-text>
                            <h5>Exportaciones y Rectificaciones</h5>
                            <v-select :items="anios" :menu-props="{ top: true, offsetY: true }" label="Seleccionar el Año" v-model="a2"></v-select>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog2 = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="estadisticaGrafica2">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>

        </v-col>

        <!-- GRAFICA 3 -->
        <v-col cols="12" lg="4" style="padding-top:0px;">
            <div ref="grafica3">
                <base-material-chart-card :options="data_grafica3" color="purple darken-4" type="Bar">

                    <h5 class="card-title font-weight-light mt-2 ml-2">Remesas</h5>
                    <table class="table text-center">
                        <tr>
                            <td></td>
                            <td><span class="overline grey--text  font-weight-light">IMPO.</span></td>
                            <td> <span class="overline grey--text  font-weight-light">EXPO.</span></td>
                            <td> <span class="overline grey--text  font-weight-light">TOTAL</span></td>
                        </tr>
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">PEDIMENTOS</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalA_G3}}</span></td>
                            <td> <span class="overline black--text  font-weight-light">{{totalB_G3}}</span></td>
                            <td> <span class="overline black--text  font-weight">{{totalA_G3 + totalB_G3}}</span></td>
                        </tr>
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">REMESAS</span></td>
                            <td><span class="overline black--text  font-weight-light">{{totalC_G3}}</span></td>
                            <td> <span class="overline black--text  font-weight-light">{{totalD_G3}}</span></td>
                            <td> <span class="overline black--text  font-weight">{{totalC_G3 + totalD_G3}}</span></td>
                        </tr>
                        <tr>
                            <td><span class="overline grey--text  font-weight-light">COMPLEMENTARIOS</span></td>
                            <td><span class="overline black--text  font-weight-light">0</span></td>
                            <td> <span class="overline black--text  font-weight-light">{{totalD_CT}}</span></td>
                            <td> <span class="overline black--text  font-weight">{{totalD_CT}}</span></td>
                        </tr>
                    </table>
                    <hr />
                    <div class="pl-5">
                        <v-btn class="mr-1 secondary--text" light icon title="Seleccionar Año" @click="dialog3 = !dialog3" v-tippy>
                            <v-icon>mdi-calendar</v-icon><span class="caption secondary--text  font-weight-light">Año {{a3}}</span>
                        </v-btn>
                    </div>
                </base-material-chart-card>
                <v-dialog v-model="dialog3" max-width="500px">
                    <v-card>

                        <v-card-text>
                            <h5>Remesas</h5>
                            <v-select :items="anios" :menu-props="{ top: true, offsetY: true }" label="Seleccionar el Año" v-model="a3"></v-select>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog3 = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="estadisticaGrafica3">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </v-col>

    </v-row>
    <v-row ref="botones" style="margin:-0px !important; padding:0 !important">
        <v-col cols="12" lg="4" style="text-align:center">
            <v-btn small color="light-blue darken-4" @click="detallesGraficas('Importaciones')" v-scroll-to="{el:'#el'}">
                <v-icon x-small color="white">mdi-eye</v-icon>&nbsp; Detalle Importaciones
            </v-btn>

        </v-col>

        <v-col cols="12" lg="4" style="text-align:center">
            <v-btn small color="teal darken-4" @click="detallesGraficas('Exportaciones')">
                <v-icon x-small color="white">mdi-eye</v-icon>&nbsp; Detalle Exportaciones
            </v-btn>
        </v-col>
        <v-col cols="12" lg="4" style="text-align:right">

            <v-btn small color="red" @click="descargar_graficas">
                <v-icon small color="white">mdi-file-pdf-box</v-icon>&nbsp; Descargar Gráficas PDF
            </v-btn>
        </v-col>
    </v-row>
    <v-row v-if="data_tableG.length > 0" ref="tabla_detalle" style="margin:0 !important; padding:0 !important">
        <v-col cols="12" style="text-align:right">

            <div class="d-inline-flex text-right" style=" z-index:1;    width:100%">
                <h5 text-primary>{{titulo_detalle}}</h5>
                <v-spacer />
                <exportar-excel :data="data_tableG" :exportFields="data_tableG_excel" name="DetalleGrafica.xlsx">
                    <v-btn x-small icon color="green" title="Descargar Información" v-tippy>
                        <v-icon dark>mdi-table</v-icon>
                    </v-btn>
                </exportar-excel>
            </div>
            <v-client-table ref="vuetableG" :data="data_tableG" :columns="columns_tableG" :options="tableG_options" class="elevation-2 pa-2 footer-hide">
                <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                </template>

                <div slot="peso_bruto_p" slot-scope="props" class="text-end">{{formatNumber(props.row.peso_bruto_p.toFixed(2))}}</div>
                <div slot="valor_dls_p" slot-scope="props" class="text-end">{{formatNumber(props.row.valor_dls_p.toFixed(2))}}</div>
                <div slot="valor_total_p" slot-scope="props" class="text-end">{{formatNumber(props.row.valor_total_p.toFixed(2))}}</div>
                <div slot="peso_bruto_r" slot-scope="props" class="text-end">{{formatNumber(props.row.peso_bruto_r.toFixed(2))}}</div>
                <div slot="valor_dls_r" slot-scope="props" class="text-end">{{formatNumber(props.row.valor_dls_r.toFixed(2))}}</div>
                <div slot="valor_total_r" slot-scope="props" class="text-end">{{formatNumber(props.row.valor_total_r.toFixed(2))}}</div>
            </v-client-table>

        </v-col>
    </v-row>
    <div id="el" style="height: 200px;"></div>
</v-container>
</template>

<script>
var colors_bars = [
    "#eb7601", //naranja
    "#ffde17", //amarillo
    "#006594", //azul
    "#56baec", // azul cielo
     "#ffffff" // azul cielo
];
import axios from "axios";
import moment from "moment";
//import Canvg from 'canvg';
import jsPDF from 'jspdf';
//import html2canvas from 'html2canvas';

//window.html2canvas = html2canvas

export default {
    name: "DashboardDashboard",
    watch: {
        coneliminados() {
            if (this.$local_storage.get("perfil_grupo") != 43 ){
                this.estadisticaTablaD();
                this.estadisticaConsultaD();
            }

        }
    },
    data() {
        return {
            ver: false,
            anio_recuperacion: "",
            titulo_detalle: "",
            valid: true,
            loader: null,
            loading: false,
            pedimentosB: 0,
            remesasB: 0,
            consultaB: "",
            consultaC: {
                "impo": 0,
                "expo": 0
            },
            consultaD: "",
            coneliminados: false,
            consultaG1: "",
            consultaG2: "",
            consultaG3: "",

            tablaB: "",
            impoC: 0,
            expoC: 0,
            impoD: 0,
            expoD: 0,
            filtroB: "",
            correctos: 0,
            incorrectos: 0,
            selected: 1,
            fab: false,
            dialog1: false,
            dialog2: false,
            dialog3: false,
            menuB: false,
            menuC: false,
            menuD: false,
            dialogA1: false,
            dialogB1: false,
            dialogC1: false,
            dialogD1: false,
            dialogA2: false,
            dialogB2: false,
            dialogC2: false,
            dialogD2: false,
            menuA1: false,
            menuA2: false,
            menuB1: false,
            menuB2: false,
            menuC1: false,
            menuC2: false,
            menuD1: false,
            menuD2: false,
            fechaA_de: "",
            fechaA_a: "",
            fechaB_de: "",
            fechaB_a: "",
            fechaC_de: "",
            fechaC_a: "",
            fechaD_de: "",
            fechaD_a: "",
            mesB: "",
            mesC: "",
            mesD: "",
            mes1: "",
            mes2: "",
            mes3: "",
            a1: "",
            a2: "",
            a3: "",

            data_grafica1: {
                chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 150,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },

                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Pedimentos",
                        data: [],
                        stack: "Pedimentos"
                    },
                    {
                        name: "Remesas",
                        data: [],
                        stack: "Remesas"
                    },
                    {
                        name: "Rectificaciones",
                        data: [],
                        stack: "Rectificaciones"
                    },

                ]
            },
            totalA_G1: 0,
            totalR_G1: 0,
            totalB_G1: 0,
            data_grafica2: {

                chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 150,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Pedimentos",
                        data: [],
                        stack: "Pedimentos"
                    },
                    {
                        name: "Remesas",
                        data: [],
                        stack: "Remesas"
                    },
                    {
                        name: "Rectificaciones",
                        data: [],
                        stack: "Rectificaciones"
                    },

                ]
            },
            totalA_G2: 0,
            totalR_G2: 0,
            totalB_G2: 0,
            data_grafica3: {
                chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 150,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Pedimentos Importaciones",
                        data: [],
                        stack: "Pedimentos Importaciones"
                    },
                    {
                        name: "Pedimentos Exportaciones",
                        data: [],
                        stack: "Pedimentos Exportaciones"
                    },
                    {
                        name: "Remesas Importaciones",
                        data: [],
                        stack: "Remesas Importaciones"
                    },
                    {
                        name: "Remesas Exportaciones",
                        data: [],
                        stack: "Remesas Exportaciones"
                    },
                    {
                        name: "Complementarios",
                        data: [],
                        stack: "Complementarios"
                    },

                ]
            },
            totalA_G3: 0,
            totalB_G3: 0,
            totalC_G3: 0,
            totalD_G3: 0,
            totalD_CT: 0,

            //MENSAJES DE CORREO
            data_tableA: [],
            columns_tableA: [
                "usuario",
                "referencia",
                "estatus",
                "error",
                "fecha",
                "mensaje",
            ],
            tableA_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                headings: {
                    "Usuario": "usuario",
                    "Referencia": "referencia",
                    "Estatus": "estatus",
                    "Error": "error",
                    "Fecha": "fecha",
                    "Mensaje": "mensaje"
                }
            },
            data_tableA_excel: {
                "Usuario": "usuario",
                "Referencia": "referencia",
                "Estatus": "estatus",
                "Error": "error",
                "Fecha": "fecha",
                "Mensaje": "mensaje"
            },

            //////////////////

            //TABLA CONSULTA DIARIA
            data_tableB: [],
            columns_tableB: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "TipoCambio",
                "ValorComercial",
                "PesoBruto",
                "CuentaRemesas"
            ],
            tableB_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. de Pedimento",
                    "FechaPagoReal": "Fecha Pago Real",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "TipoCambio": "Tipo Cambio",
                    "ValorComercial": "Valor Comercial",
                    "PesoBruto": "Peso Bruto",
                    "CuentaRemesas": "Cuenta Remesas",
                }
            },
            data_tableB_excel: {

                "No. de Pedimento": "NoPedimento",
                "Fecha Pago Real": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Tipo Cambio": "TipoCambio",
                "Valor Comercial": "ValorComercial",
                "Peso Bruto": "PesoBruto",
                "Cuenta Remesas": "CuentaRemesas",
                "Medio Transporte": "MedioTransporte",
                "No. Operación": "NoOperacion"
            },

            //TABLA REVISION
            data_tableC: [],
            columns_tableC: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "Estado",
                "DescripcionEstado",
                "SubEstado",
                "DescripcionSubEstado",
                "FechaCambio",
                "Secuencia",
                "Factura",
                "Cantidad",
                "Valor"

            ],
            tableC_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. Pedimento",
                    "FechaPagoReal": "Fecha Pago",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "Estado": "Estado",
                    "DescripcionEstado": "Descripción Estado",
                    "SubEstado": "Subestado",
                    "DescripcionSubEstado": "Descripción Subestado",
                    "FechaCambio": "Fecha Cambio",
                    "Secuencia": "Secuencia",
                    "Factura": "Factura",
                    "Cantidad": "Cantidad",
                    "Valor": "Valor"
                }
            },
            data_tableC_excel: {
                "No. Pedimento": "NoPedimento",
                "Fecha Pago": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Fecha Estado": "FechaEstado",
                "Descripción": "Descripcion",
                "Numéro Prevalidador": "NumeroPrevalidador",
                "Estado": "Estado",
                "Descripción Edo.": "DescripcionEstado",
                "Subestado": "SubEstado",
                "Descripción Subestado": "DescripcionSubEstado",
                "Fecha Cambio": "FechaCambio",
                "Secuencia": "Secuencia",
                "Factura": "Factura",
                "Cantidad": "Cantidad",
                "Valor": "Valor"

            },

            //TABLA DETALLE GRAFICAS
            data_tableG: [],
            columns_tableG: [
                "tipo_operacion",
                "mes",
                "pedimentos",
                "remesas",
                "peso_bruto_p",
                "valor_dls_p",
                "valor_total_p",
                "rectificaciones",
                "peso_bruto_r",
                "valor_dls_r",
                "valor_total_r",

            ],
            tableG_options: {
                filterable: false,
                filterByColumn: false,
                perPage: 100,
                orderBy: {
                    column: 'mes',
                    ascending: true
                },
                headings: {
                    "tipo_operacion": "Tipo Operación",
                    "mes": "Mes",
                    "pedimentos": "Pedimentos",
                    "remesas": "Remesas",
                    "peso_bruto_p": "Peso Bruto",
                    "valor_dls_p": "Valor DLS",
                    "valor_total_p": "Valor MN",
                    "rectificaciones": "Rectificaciones",
                    "peso_bruto_r": "Peso Bruto Rectificaciones",
                    "valor_dls_r": "Valor DLS Rectificaciones",
                    "valor_total_r": "Valor MN Rectificaciones",
                }
            },
            data_tableG_excel: {
                "Tipo Operación": "tipo_operacion",
                "Mes": "mes",
                "Pedimento": "pedimentos",
                "Remesas": "remesas",
                "Peso Bruto": "peso_bruto_p",
                "Valor Dolares": "valor_dls_p",
                "Valor Total": "valor_total_p",
                "Rectificaciones": "rectificaciones",
                "Peso Bruto Rectificaciones": "peso_bruto_r",
                "Valor DLS Rectificaciones": "valor_dls_r",
                "Valor MN Rectificaciones": "valor_total_r",

            },

            //TABLA REVISION
            data_tableD: [],
            columns_tableD: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "Estado",
                "DescripcionEstado",
                "SubEstado",
                "DescripcionSubEstado",
                "FechaCambio",
                "Secuencia",
                "Factura",
                "Cantidad",
                "Valor"

            ],
            tableD_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. Pedimento",
                    "FechaPagoReal": "Fecha Pago",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "Estado": "Estado",
                    "DescripcionEstado": "Descripción Edo.",
                    "SubEstado": "Subestado",
                    "DescripcionSubEstado": "Descripción Subestado",
                    "FechaCambio": "Fecha Cambio",
                    "Secuencia": "Secuencia",
                    "Factura": "Factura",
                    "Cantidad": "Cantidad",
                    "Valor": "Valor"
                }
            },
            data_tableD_excel: {
                "No. Pedimento": "NoPedimento",
                "Fecha Pago": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Descripción": "Descripcion",
                "Numéro Prevalidador": "NumeroPrevalidador",
                "Estado": "Estado",
                "Descripción Edo.": "DescripcionEstado",
                "Subestado": "SubEstado",
                "Descripción Subestado": "DescripcionSubEstado",
                "Fecha Cambio": "FechaCambio",
                "Secuencia": "Secuencia",
                "Factura": "Factura",
                "Cantidad": "Cantidad",
                "Valor": "Valor"
            },
        };
    },

    computed: {
        soloSoluciona() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
            this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 &&
             (this.$local_storage.get("EmanifiestoMV.bitacora") != 100 ) && this.$local_storage.get( "Logistica.nuevoregistro" ) != 100
             && (this.$local_storage.get("Modulo15") == 100 || this.$local_storage.get("Modulo16") == 100);
        },
        expediente() {
            return (

                this.$local_storage.get(
                    "BANDEJA.DE.CORREO"
                ) == 100
            );
        },
        is_consignatario() {
            return this.$local_storage.get("subtipo_usuario") == "embarcadores_consignatarios";
        },
        anios() {
            var f = new Date();
            let a = [];
            let y = f.getFullYear();
            let i = 1;
            for (i; i < 15; i++) {
                a.push(y)
                y = y - 1;
            }
            return a;
        },

         soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("Emanifiesto.bitacora") == 100;
        },
    },
    mounted() {
       this.ver = true;
    },
    async created() {


        if (this.$local_storage.get("es_transportista")==1)
            this.$router.replace("/indext").catch(() => {});

        if (this.$local_storage.get("es_agente")==1)
            this.$router.replace("/indexAA").catch(() => {});

        if (this.$local_storage.get("soloCartaPorte") == 100)
                    this.$router.replace("/indext").catch(()=>{});

        if (this.$local_storage.get("Modulo14") == 100 && this.$local_storage.get("id_cliente") > 0)
            this.$router.replace("/indexAAC").catch(()=>{});

        if (this.$store.state.emanifiesto== true)
                  this.$router.replace("/manifestacion/transmitir").catch(()=>{});

        if (this.$store.state.costing== true)
                     this.$router.replace("/facturastransito").catch(()=>{});

        if (this.$store.state.trafico== true)
                     this.$router.replace("/trafico_index").catch(()=>{});

       if (this.$store.state.sa31 == true || this.$local_storage.get("soloSA31")==100 )
            this.$router.replace("/indexsa31").catch(() => {});
        if (this.$store.state.sa24 == true || this.$local_storage.get("soloSA24")==100 )
            this.$router.replace("/indexsa24").catch(() => {});
        if (this.$local_storage.get("perfil_grupo") == 43) {
            this.$router.replace("/trafico/reporte_embarques").catch(() => {});
        } else if (this.$local_storage.get("tipo_usuario") == "Super Usuario" && ["0",0].includes(this.$local_storage.get("id_cliente"))) {
            this.$router.replace("/listaclientes").catch(()=>{});
        } else {
            if (this.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") != 100 && this.$local_storage.get("VUCEM.Pedimento.consulta.cove") != 100) {
                if (this.$local_storage.get("DATA.STAGE.cargazip") == 100)
                    this.$router.replace("/datastage/bitacorazip").catch(() => {});
                else if (this.$local_storage.get("VUCEM.Transmision.ver.coves") == 100)
                    this.$router.replace("/transmision/covedetalles").catch(() => {});
                else if (this.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100)
                    this.$router.replace("/reportes/consultar_pedimentos_ws").catch(() => {});

            } else {
                var f_de = new Date();
                var f_a = new Date();

                f_de.setDate(f_de.getDate() - 7);

                let y = f_a.getFullYear();
                let m = f_a.getMonth() + 1;
                let d = f_a.getDate();

                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                this.a1 = y;
                this.a2 = y;
                this.a3 = y;
                if (m < 10)
                    m = '0' + m;
                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d < 10)
                    d = '0' + d;
                if (d_de < 10)
                    d_de = '0' + d_de;
                this.mesB = y + "-" + m;
                this.mesC = y + "-" + m;
                this.mesD = y;

                let fecha_a = y + "-" + m + "-" + d;
                let fecha_de = y_de + "-" + m_de + "-" + d_de;
                this.fechaA_a = fecha_a;
                this.fechaA_de = y_de + "-" + m_de + "-01";
                this.fechaB_a = fecha_a;
                this.fechaB_de = fecha_de;
                this.fechaC_a = fecha_a;
                this.fechaC_de = y_de + "-" + m_de + "-01";
                this.fechaD_a = fecha_a;
                this.fechaD_de = y + "-01-01";
                this.selected = 2;
                if (this.expediente) {
                     this.estadisticaConsultaA();
                }
                 this.getAnioRecuperacion();
                 this.estadisticaTablaB();
                 this.estadisticaConsultaB();
                 this.estadisticaConsultaC();
                 this.estadisticaConsultaD();
                 this.estadisticaGrafica1();
                 this.estadisticaGrafica2();
                 this.estadisticaGrafica3();

            }

        }

    },
    methods: {
         openDialog(){

            this.dialogA2 =  true;

        },
        filterResult() {
            Event.$emit('vue-tables.filter::filtro', this.filtro);
        },
        complete(index) {
            this.list[index] = !this.list[index];
        },
        getAnioRecuperacion:function(){
            let id_cliente = this.$local_storage.get("id_cliente", 0);
            if( id_cliente > 0){
                axios.get(this.$hostname + "clientes/" + id_cliente + "/")
                .then(response => {
                    if(response.data !=null && response.data.anio_recuperacion!=null)
                        this.anio_recuperacion = response.data.anio_recuperacion;
                    else
                        this.anio_recuperacion = "";
                })
                .catch(error => {
                });
            }

        },
        async estadisticaConsultaA() {
            var datos = {
                rfc: this.$local_storage.get("rfc"),
                fecha_de : this.fechaA_de,
                fecha_a:  this.fechaA_a
            }
            this.correctos = 0;
            this.incorrectos = 0;
            await axios.post(this.$hostname + 's3/facturas3/get_conteo_bandeja/', datos)
                .then((response) => {
                    //console.log(response.data);
                    if (response.data[0] != undefined) {
                        this.correctos = (response.data[0].correctos);
                        this.incorrectos = (response.data[0].incorrectos);
                    }
                    if (response.data[0] != undefined && response.data[1] != undefined) {
                        this.correctos = (response.data[0].correctos + response.data[1].correctos);
                        this.incorrectos = (response.data[0].incorrectos + response.data[1].incorrectos);
                    }

                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async estadisticaConsultaB() {

            let m = this.mesB.split("-");
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 1,
                "anio": m[0],
                "mes": m[1]
            }

            await axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {
                    this.consultaB = response.data;
                    this.remesasB = parseInt(this.consultaB.remesas) + parseInt(this.consultaB.remesas_desaduanados);
                    this.pedimentosB = parseInt(this.consultaB.pedimentos) + parseInt(this.consultaB.pedimentos_desaduanados);

                })
                .catch((error) => {
                    this.consultaB = {
                        "pedimentos": 0,
                        "remesas": 0,
                        "pedimentos_desaduanados": 0,
                        "remesas_desaduanados": 0
                    };
                    this.remesasB = 0;
                    this.pedimentosB = 0;

                }).then(() => {
                    this.dialogB1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaConsultaC() {

            let m = this.mesC.split("-");
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 3,
                "anio": m[0],
                "mes": m[1],
                "estados": ["310","4", "410"]
                // "estados": ["310", "330", "340", "410", "415", "420", "430", "440", "450", "460", "480", "481", "482", "490", "491", "510", "520", "530", "610", "620", "630", "720 ", "750", "760"]
            }

            await axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {
                    this.consultaC = response.data;
                    this.impoC = parseInt(this.consultaC.impo);
                    this.expoC = parseInt(this.consultaC.expo);
                })
                .catch((error) => {
                    this.consultaC = {
                        "impo": 0,
                        "expo": 0,
                    };
                    this.impoC = 0;
                    this.expoC = 0;

                }).then(() => {
                    this.dialogC1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaConsultaD() {
            let alertas = [];
            if (this.coneliminados) {
                alertas = ["140"];
            } else {
                alertas = ["330", "340", "415", "460", "480","482", "490", "492", "630", "720", "750"];
                // alertas = ["330", "340", "415", "460", "530", "630", "720", "750"];
            }
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 3,
                "anio": this.mesD,
                "estados": alertas
            }

            await axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {
                    this.consultaD = response.data;
                    this.impoD = parseInt(this.consultaD.impo);
                    this.expoD = parseInt(this.consultaD.expo);
                })
                .catch((error) => {
                    this.consultaD = {
                        "impo": 0,
                        "expo": 0,
                    };
                    this.impoD = 0;
                    this.expoD = 0;
                }).then(() => {
                    this.dialogD1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },

        async estadisticaTablaA() {

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                rfc: this.$local_storage.get("rfc"),
                fecha_de: this.fechaA_de,
                fecha_a: this.fechaA_a,
            }
            await axios.post(this.$hostname + 's3/facturas3/get_mensajes_bandeja/', datos)
                .then((response) => {
                    this.data_tableA = response.data;
                })
                .catch((error) => {
                    this.data_tableA = [];

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.loader = null;
                    this.loading = false;
                    this.dialogA2 = false;
                    this.estadisticaConsultaA();

                });

        },
        estadisticaTablaB() {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 2,
                "fecha_de": this.fechaB_de,
                "fecha_a": this.fechaB_a,
            }

            axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {

                    self.data_tableB = response.data;
                    self.data_tableB.forEach(element => {
                        let a = element.FechaPagoReal.split('-')
                        element.FechaPagoReal = a[2] + '-' + a[1] + '-' + a[0];
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.data_tableB = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogB2 = false;
                    this.loader = null;
                    this.loading = false;
                });

        },
        estadisticaTablaC() {
             let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 4,
                "fecha_de": this.fechaC_de,
                "fecha_a": this.fechaC_a,
                "estados": ["310","4", "410"]

                //   "estados": ["310", "330", "340", "410", "415", "420", "430", "440", "450", "460", "480", "481", "482", "490", "491", "510", "520", "530", "610", "620", "630", "720", "750", "760"]

            }

            axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {
                    this.data_tableC = response.data;
                     self.data_tableC.forEach(element => {
                        let a = element.FechaPagoReal.split('-')
                        element.FechaPagoReal = a[2] + '-' + a[1] + '-' + a[0];
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.data_tableC = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogC2 = false;
                    this.loader = null;
                    this.loading = false;
                });

        },
        estadisticaTablaD() {
             let self = this;
            let alertas = [];
            if (this.coneliminados) {
                alertas = ["140"];
            } else {
                alertas = ["330", "340", "415", "460", "480", "490", "492", "630", "720", "750"];
            }
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 4,
                "fecha_de": this.fechaD_de,
                "fecha_a": this.fechaD_a,
                "estados": alertas
            }

            axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {
                    this.data_tableD = response.data;
                    self.data_tableD.forEach(element => {
                        let a = element.FechaPagoReal.split('-')
                        element.FechaPagoReal = a[2] + '-' + a[1] + '-' + a[0];
                    });
                })
                .catch((error) => {
                    this.data_tableD = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogD2 = false;
                    this.loader = null;
                    this.loading = false;
                });

        },

        async estadisticaGrafica1() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 5,
                "anio": this.a1,
            }
            await axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {
                    let r = response.data;
                    let tp = 0;
                    let tr = 0;
                    let tremesas = 0;
                    let m = [];
                    let vp = [];
                    let vr = [];
                    let vremesas = [];
                    if (r.Enero) {
                        m.push("Ene");
                        vp.push(r.Enero.pedimentos);
                        vr.push(r.Enero.reconocimientos);
                        tp = tp + r.Enero.pedimentos;
                        tr = tr + r.Enero.reconocimientos;
                        vremesas.push(r.Enero.remesas);
                        tremesas = tremesas + r.Enero.remesas;
                    }
                    if (r.Febrero) {
                        m.push("Feb");
                        vp.push(r.Febrero.pedimentos);
                        vr.push(r.Febrero.reconocimientos);
                        tp = tp + r.Febrero.pedimentos;
                        tr = tr + r.Febrero.reconocimientos;
                        vremesas.push(r.Febrero.remesas);
                        tremesas = tremesas + r.Febrero.remesas;
                    }
                    if (r.Marzo) {
                        m.push("Mar");
                        vp.push(r.Marzo.pedimentos);
                        vr.push(r.Marzo.reconocimientos);
                        tp = tp + r.Marzo.pedimentos;
                        tr = tr + r.Marzo.reconocimientos;
                        vremesas.push(r.Marzo.remesas);
                        tremesas = tremesas + r.Marzo.remesas;
                    }
                    if (r.Abril) {
                        m.push("Abr");
                        vp.push(r.Abril.pedimentos);
                        vr.push(r.Abril.reconocimientos);
                        tp = tp + r.Abril.pedimentos;
                        tr = tr + r.Abril.reconocimientos;
                        vremesas.push(r.Abril.remesas);
                        tremesas = tremesas + r.Abril.remesas;
                    }
                    if (r.Mayo) {
                        m.push("May");
                        vp.push(r.Mayo.pedimentos);
                        vr.push(r.Mayo.reconocimientos);
                        tp = tp + r.Mayo.pedimentos;
                        tr = tr + r.Mayo.reconocimientos;
                        vremesas.push(r.Mayo.remesas);
                        tremesas = tremesas + r.Mayo.remesas;
                    }
                    if (r.Junio) {
                        m.push("Jun");
                        vp.push(r.Junio.pedimentos);
                        vr.push(r.Junio.reconocimientos);
                        tp = tp + r.Junio.pedimentos;
                        tr = tr + r.Junio.reconocimientos;
                        vremesas.push(r.Junio.remesas);
                        tremesas = tremesas + r.Junio.remesas;
                    }
                    if (r.Julio) {
                        m.push("Jul");
                        vp.push(r.Julio.pedimentos);
                        vr.push(r.Julio.reconocimientos);
                        tp = tp + r.Julio.pedimentos;
                        tr = tr + r.Julio.reconocimientos;
                        vremesas.push(r.Julio.remesas);
                        tremesas = tremesas + r.Julio.remesas;
                    }
                    if (r.Agosto) {
                        m.push("Ago");
                        vp.push(r.Agosto.pedimentos);
                        vr.push(r.Agosto.reconocimientos);
                        tp = tp + r.Agosto.pedimentos;
                        tr = tr + r.Agosto.reconocimientos;
                        vremesas.push(r.Agosto.remesas);
                        tremesas = tremesas + r.Agosto.remesas;
                    }
                    if (r.Septiembre) {
                        m.push("Sep");
                        vp.push(r.Septiembre.pedimentos);
                        vr.push(r.Septiembre.reconocimientos);
                        tp = tp + r.Septiembre.pedimentos;
                        tr = tr + r.Septiembre.reconocimientos;
                        vremesas.push(r.Septiembre.remesas);
                        tremesas = tremesas + r.Septiembre.remesas;
                    }
                    if (r.Octubre) {
                        m.push("Oct");
                        vp.push(r.Octubre.pedimentos);
                        vr.push(r.Octubre.reconocimientos);
                        tp = tp + r.Octubre.pedimentos;
                        tr = tr + r.Octubre.reconocimientos;
                        vremesas.push(r.Octubre.remesas);
                        tremesas = tremesas + r.Octubre.remesas;
                    }
                    if (r.Noviembre) {
                        m.push("Nov");
                        vp.push(r.Noviembre.pedimentos);
                        vr.push(r.Noviembre.reconocimientos);
                        tp = tp + r.Noviembre.pedimentos;
                        tr = tr + r.Noviembre.reconocimientos;
                        vremesas.push(r.Noviembre.remesas);
                        tremesas = tremesas + r.Noviembre.remesas;
                    }
                    if (r.Diciembre) {
                        m.push("Dic");
                        vp.push(r.Diciembre.pedimentos);
                        vr.push(r.Diciembre.reconocimientos);
                        tp = tp + r.Diciembre.pedimentos;
                        tr = tr + r.Diciembre.reconocimientos;
                        vremesas.push(r.Diciembre.remesas);
                        tremesas = tremesas + r.Diciembre.remesas;
                    }
                    this.data_grafica1.xAxis.categories = m;
                    this.data_grafica1.series[0].data = vp;
                    this.data_grafica1.series[1].data = vremesas;
                    this.data_grafica1.series[2].data = vr;
                    this.totalA_G1 = tp;
                    this.totalB_G1 = tr;
                    this.totalR_G1 = tremesas;
                    if (this.data_tableG.length > 0) {
                        this.detallesGraficas('Importaciones')
                    }
                })
                .catch((error) => {
                    this.data_grafica1.xAxis.categories = [];
                    this.data_grafica1.series[0].data = [];
                    this.data_grafica1.series[1].data = [];
                    this.data_grafica1.series[2].data = [];
                    this.totalA_G1 = 0;
                    this.totalB_G1 = 0;
                    this.totalR_G1 = 0;
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaGrafica2() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 6,
                "anio": this.a2,
            }
            await axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {
                    let r = response.data;
                    console.log(r);
                    let tp = 0;
                    let tr = 0;
                    let tremesas = 0;
                    let m = [];
                    let vp = [];
                    let vr = [];
                    let vremesas = [];
                    if (r.Enero != undefined) {
                        m.push("Ene");
                        vp.push(r.Enero.pedimentos);
                        vr.push(r.Enero.reconocimientos);
                        tp = tp + r.Enero.pedimentos;
                        tr = tr + r.Enero.reconocimientos;
                        vremesas.push(r.Enero.remesas);
                        tremesas = tremesas + r.Enero.remesas;
                    }
                    if (r.Febrero != undefined) {
                        m.push("Feb");
                        vp.push(r.Febrero.pedimentos);
                        vr.push(r.Febrero.reconocimientos);
                        tp = tp + r.Febrero.pedimentos;
                        tr = tr + r.Febrero.reconocimientos
                        vremesas.push(r.Febrero.remesas);
                        tremesas = tremesas + r.Febrero.remesas;
                    }
                    if (r.Marzo != undefined) {
                        m.push("Mar");
                        vp.push(r.Marzo.pedimentos);
                        vr.push(r.Marzo.reconocimientos);
                        tp = tp + r.Marzo.pedimentos;
                        tr = tr + r.Marzo.reconocimientos
                        vremesas.push(r.Marzo.remesas);
                        tremesas = tremesas + r.Marzo.remesas;
                    }
                    if (r.Abril != undefined) {
                        m.push("Abr");
                        vp.push(r.Abril.pedimentos);
                        vr.push(r.Abril.reconocimientos);
                        tp = tp + r.Abril.pedimentos;
                        tr = tr + r.Abril.reconocimientos;
                        vremesas.push(r.Abril.remesas);
                        tremesas = tremesas + r.Abril.remesas;
                    }
                    if (r.Mayo != undefined) {
                        m.push("May");
                        vp.push(r.Mayo.pedimentos);
                        vr.push(r.Mayo.reconocimientos);
                        tp = tp + r.Mayo.pedimentos;
                        tr = tr + r.Mayo.reconocimientos;
                        vremesas.push(r.Mayo.remesas);
                        tremesas = tremesas + r.Mayo.remesas;
                    }
                    if (r.Junio != undefined) {
                        m.push("Jun");
                        vp.push(r.Junio.pedimentos);
                        vr.push(r.Junio.reconocimientos);
                        tp = tp + r.Junio.pedimentos;
                        tr = tr + r.Junio.reconocimientos;
                        vremesas.push(r.Junio.remesas);
                        tremesas = tremesas + r.Junio.remesas;
                    }
                    if (r.Julio != undefined) {
                        m.push("Jul");
                        vp.push(r.Julio.pedimentos);
                        vr.push(r.Julio.reconocimientos);
                        tp = tp + r.Julio.pedimentos;
                        tr = tr + r.Julio.reconocimientos;
                        vremesas.push(r.Julio.remesas);
                        tremesas = tremesas + r.Julio.remesas;
                    }
                    if (r.Agosto != undefined) {
                        m.push("Ago");
                        vp.push(r.Agosto.pedimentos);
                        vr.push(r.Agosto.reconocimientos);
                        tp = tp + r.Agosto.pedimentos;
                        tr = tr + r.Agosto.reconocimientos;
                        vremesas.push(r.Agosto.remesas);
                        tremesas = tremesas + r.Agosto.remesas;
                    }
                    if (r.Septiembre != undefined) {
                        m.push("Sep");
                        vp.push(r.Septiembre.pedimentos);
                        vr.push(r.Septiembre.reconocimientos);
                        tp = tp + r.Septiembre.pedimentos;
                        tr = tr + r.Septiembre.reconocimientos;
                        vremesas.push(r.Septiembre.remesas);
                        tremesas = tremesas + r.Septiembre.remesas;
                    }
                    if (r.Octubre != undefined) {
                        m.push("Oct");
                        vp.push(r.Octubre.pedimentos);
                        vr.push(r.Octubre.reconocimientos);
                        tp = tp + r.Octubre.pedimentos;
                        tr = tr + r.Octubre.reconocimientos;
                        vremesas.push(r.Octubre.remesas);
                        tremesas = tremesas + r.Octubre.remesas;
                    }
                    if (r.Noviembre != undefined) {
                        m.push("Nov");
                        vp.push(r.Noviembre.pedimentos);
                        vr.push(r.Noviembre.reconocimientos);
                        tp = tp + r.Noviembre.pedimentos;
                        tr = tr + r.Noviembre.reconocimientos;
                        vremesas.push(r.Noviembre.remesas);
                        tremesas = tremesas + r.Noviembre.remesas;
                    }
                    if (r['Diciembre'] != undefined) {
                        m.push("Dic");
                        vp.push(r['Diciembre'].pedimentos);
                        vr.push(r['Diciembre'].reconocimientos);
                        tp = tp + r['Diciembre'].pedimentos;
                        tr = tr + r['Diciembre'].reconocimientos;
                        vremesas.push(r['Diciembre'].remesas);
                        tremesas = tremesas + r.Diciembre.remesas;
                    }
                    console.log('llega')
                    this.data_grafica2.xAxis.categories = m;
                    this.data_grafica2.series[0].data = vp;
                    this.data_grafica2.series[1].data = vremesas;
                    this.data_grafica2.series[2].data = vr;
                    console.log(this.data_grafica2);
                    this.totalA_G2 = tp;
                    this.totalB_G2 = tr;
                    this.totalR_G2 = tremesas;
                    if (this.data_tableG.length > 0) {
                        this.detallesGraficas('Exportaciones')
                    }

                })
                .catch((error) => {
                    console.log(error);
                    this.data_grafica2.xAxis.categories = [];
                    this.data_grafica2.series[0].data = [];
                    this.data_grafica2.series[1].data = [];
                    this.data_grafica2.series[2].data = [];
                    this.totalA_G2 = 0;
                    this.totalB_G2 = 0;
                    this.totalR_G2 = 0;
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog2 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaGrafica3() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 7,
                "anio": this.a3,
            }
            await axios.post(this.$hostname + 'reportes/estadisticas/', datos)
                .then((response) => {
                    let r = response.data;;
                    let tp_i = 0;
                    let tr_i = 0;
                    let tp_e = 0;
                    let tr_e = 0;
                    let tct = 0;
                    let m = [];
                    let vp_e = [];
                    let vr_e = [];
                    let vp_i = [];
                    let vr_i = [];
                    let vct = [];
                    if (r.Enero) {
                        m.push("Ene");
                        vp_i.push(r.Enero.pedimentos_impo);
                        vr_i.push(r.Enero.remesas_impo);
                        vp_e.push(r.Enero.pedimentos_expo);
                        vr_e.push(r.Enero.remesas_expo);

                        tp_i = tp_i + r.Enero.pedimentos_impo;
                        tr_i = tr_i + r.Enero.remesas_impo;
                        tp_e = tp_e + r.Enero.pedimentos_expo;
                        tr_e = tr_e + r.Enero.remesas_expo;

                        vct.push(r.Enero.pedimentos_ct);
                        tct = tct + r.Enero.pedimentos_ct;
                    }
                    if (r.Febrero) {
                        m.push("Feb");
                        vp_i.push(r.Febrero.pedimentos_impo);
                        vr_i.push(r.Febrero.remesas_impo);
                        vp_e.push(r.Febrero.pedimentos_expo);
                        vr_e.push(r.Febrero.remesas_expo);
                        tp_i = tp_i + r.Febrero.pedimentos_impo;
                        tr_i = tr_i + r.Febrero.remesas_impo;
                        tp_e = tp_e + r.Febrero.pedimentos_expo;
                        tr_e = tr_e + r.Febrero.remesas_expo;
                         vct.push(r.Febrero.pedimentos_ct);
                        tct = tct + r.Febrero.pedimentos_ct;
                    }
                    if (r.Marzo) {
                        m.push("Mar");
                        vp_i.push(r.Marzo.pedimentos_impo);
                        vr_i.push(r.Marzo.remesas_impo);
                        vp_e.push(r.Marzo.pedimentos_expo);
                        vr_e.push(r.Marzo.remesas_expo);
                        tp_i = tp_i + r.Marzo.pedimentos_impo;
                        tr_i = tr_i + r.Marzo.remesas_impo;
                        tp_e = tp_e + r.Marzo.pedimentos_expo;
                        tr_e = tr_e + r.Marzo.remesas_expo;
                          vct.push(r.Marzo.pedimentos_ct);
                        tct = tct + r.Marzo.pedimentos_ct;
                    }
                    if (r.Abril) {
                        m.push("Abr");
                        vp_i.push(r.Abril.pedimentos_impo);
                        vr_i.push(r.Abril.remesas_impo);
                        vp_e.push(r.Abril.pedimentos_expo);
                        vr_e.push(r.Abril.remesas_expo);
                        tp_i = tp_i + r.Abril.pedimentos_impo;
                        tr_i = tr_i + r.Abril.remesas_impo;
                        tp_e = tp_e + r.Abril.pedimentos_expo;
                        tr_e = tr_e + r.Abril.remesas_expo;
                         vct.push(r.Abril.pedimentos_ct);
                        tct = tct + r.Abril.pedimentos_ct;
                    }
                    if (r.Mayo) {
                        m.push("May");
                        vp_i.push(r.Mayo.pedimentos_impo);
                        vr_i.push(r.Mayo.remesas_impo);
                        vp_e.push(r.Mayo.pedimentos_expo);
                        vr_e.push(r.Mayo.remesas_expo);
                        tp_i = tp_i + r.Mayo.pedimentos_impo;
                        tr_i = tr_i + r.Mayo.remesas_impo;
                        tp_e = tp_e + r.Mayo.pedimentos_expo;
                        tr_e = tr_e + r.Mayo.remesas_expo;
                         vct.push(r.Mayo.pedimentos_ct);
                        tct = tct + r.Mayo.pedimentos_ct;
                    }
                    if (r.Junio) {
                        m.push("Jun");
                        vp_i.push(r.Junio.pedimentos_impo);
                        vr_i.push(r.Junio.remesas_impo);
                        vp_e.push(r.Junio.pedimentos_expo);
                        vr_e.push(r.Junio.remesas_expo);
                        tp_i = tp_i + r.Junio.pedimentos_impo;
                        tr_i = tr_i + r.Junio.remesas_impo;
                        tp_e = tp_e + r.Junio.pedimentos_expo;
                        tr_e = tr_e + r.Junio.remesas_expo;
                         vct.push(r.Junio.pedimentos_ct);
                        tct = tct + r.Junio.pedimentos_ct;
                    }
                    if (r.Julio) {
                        m.push("Jul");
                        vp_i.push(r.Julio.pedimentos_impo);
                        vr_i.push(r.Julio.remesas_impo);
                        vp_e.push(r.Julio.pedimentos_expo);
                        vr_e.push(r.Julio.remesas_expo);
                        tp_i = tp_i + r.Julio.pedimentos_impo;
                        tr_i = tr_i + r.Julio.remesas_impo;
                        tp_e = tp_e + r.Julio.pedimentos_expo;
                        tr_e = tr_e + r.Julio.remesas_expo;
                         vct.push(r.Julio.pedimentos_ct);
                        tct = tct + r.Julio.pedimentos_ct;
                    }
                    if (r.Agosto) {
                        m.push("Ago");
                        vp_i.push(r.Agosto.pedimentos_impo);
                        vr_i.push(r.Agosto.remesas_impo);
                        vp_e.push(r.Agosto.pedimentos_expo);
                        vr_e.push(r.Agosto.remesas_expo);
                        tp_i = tp_i + r.Agosto.pedimentos_impo;
                        tr_i = tr_i + r.Agosto.remesas_impo;
                        tp_e = tp_e + r.Agosto.pedimentos_expo;
                        tr_e = tr_e + r.Agosto.remesas_expo;
                         vct.push(r.Agosto.pedimentos_ct);
                        tct = tct + r.Agosto.pedimentos_ct;
                    }
                    if (r.Septiembre) {
                        m.push("Sep");
                        vp_i.push(r.Septiembre.pedimentos_impo);
                        vr_i.push(r.Septiembre.remesas_impo);
                        vp_e.push(r.Septiembre.pedimentos_expo);
                        vr_e.push(r.Septiembre.remesas_expo);
                        tp_i = tp_i + r.Septiembre.pedimentos_impo;
                        tr_i = tr_i + r.Septiembre.remesas_impo;
                        tp_e = tp_e + r.Septiembre.pedimentos_expo;
                        tr_e = tr_e + r.Septiembre.remesas_expo;
                         vct.push(r.Septiembre.pedimentos_ct);
                        tct = tct + r.Septiembre.pedimentos_ct;
                    }
                    if (r.Octubre) {
                        m.push("Oct");
                        vp_i.push(r.Octubre.pedimentos_impo);
                        vr_i.push(r.Octubre.remesas_impo);
                        vp_e.push(r.Octubre.pedimentos_expo);
                        vr_e.push(r.Octubre.remesas_expo);
                        tp_i = tp_i + r.Octubre.pedimentos_impo;
                        tr_i = tr_i + r.Octubre.remesas_impo;
                        tp_e = tp_e + r.Octubre.pedimentos_expo;
                        tr_e = tr_e + r.Octubre.remesas_expo;
                         vct.push(r.Octubre.pedimentos_ct);
                        tct = tct + r.Octubre.pedimentos_ct;
                    }
                    if (r.Noviembre) {
                        m.push("Nov");
                        vp_i.push(r.Noviembre.pedimentos_impo);
                        vr_i.push(r.Noviembre.remesas_impo);
                        vp_e.push(r.Noviembre.pedimentos_expo);
                        vr_e.push(r.Noviembre.remesas_expo);
                        tp_i = tp_i + r.Noviembre.pedimentos_impo;
                        tr_i = tr_i + r.Noviembre.remesas_impo;
                        tp_e = tp_e + r.Noviembre.pedimentos_expo;
                        tr_e = tr_e + r.Noviembre.remesas_expo;
                         vct.push(r.Noviembre.pedimentos_ct);
                        tct = tct + r.Noviembre.pedimentos_ct;
                    }
                    if (r.Diciembre) {
                        m.push("Dic");
                        vp_i.push(r.Diciembre.pedimentos_impo);
                        vr_i.push(r.Diciembre.remesas_impo);
                        vp_e.push(r.Diciembre.pedimentos_expo);
                        vr_e.push(r.Diciembre.remesas_expo);
                        tp_i = tp_i + r.Diciembre.pedimentos_impo;
                        tr_i = tr_i + r.Diciembre.remesas_impo;
                        tp_e = tp_e + r.Diciembre.pedimentos_expo;
                        tr_e = tr_e + r.Diciembre.remesas_expo;
                         vct.push(r.Diciembre.pedimentos_ct);
                        tct = tct + r.Diciembre.pedimentos_ct;
                    }
                    this.data_grafica3.xAxis.categories = m;
                    this.data_grafica3.series[0].data = vp_i;
                    this.data_grafica3.series[1].data = vp_e;
                    this.data_grafica3.series[2].data = vr_i;
                    this.data_grafica3.series[3].data = vr_e;
                    this.data_grafica3.series[4].data = vct;
                    this.totalA_G3 = tp_i;
                    this.totalB_G3 = tp_e;

                    this.totalC_G3 = tr_i;
                    this.totalD_G3 = tr_e;
                    this.totalD_CT = tct;

                })
                .catch((error) => {
                    console.log(error);
                    this.data_grafica3.xAxis.categories = [];
                    this.data_grafica3.series[0].data = [];
                    this.data_grafica3.series[1].data = [];
                    this.data_grafica3.series[2].data = [];
                    this.data_grafica3.series[3].data = [];
                    this.data_grafica3.series[4].data = [];
                    this.totalA_G3 = 0;
                    this.totalB_G3 = 0;
                    this.totalC_G3 = 0;
                    this.totalD_G3 = 0;
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog3 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        selectItem(index) {
            this.selected = index;
            if (index == 1) {
                this.estadisticaTablaA();
            }
            if (index == 2) {
                this.estadisticaTablaB();
            }
            if (index == 3) {
                this.estadisticaTablaC();
            }
            if (index == 4) {
                this.estadisticaTablaD();
            }
        },
        cambiarMesB() {
            this.dialogB1 = true;
        },
        cambiarMesC() {
            this.dialogC1 = true;
        },
        cambiarMesD() {
            this.dialogD1 = true;
        },
        formatNumber: function (x) {
            if (x == undefined) return 0;
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },
        validaFechas: function (FD, FA) {
            if (FD == null)
                FD = ""
            if (FA == null)
                FA = ""

            if (FD != "" && FD == "") {
                return "Debe seleccionar las dos fechas o ninguna.";
            } else if (FD == "" && FA != "") {
                return "Debe seleccionar las dos fechas o ninguna.";
            }
            return true;
        },
        validaMes: function (FD, FA) {
            if (FD != "" && FA != "") {
                var inicio = moment(FD, "YYYY-MM-DD");
                var fin = moment(FA, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 31)
                    return "Periodo máximo de consulta 31 días. Favor de verificar.";
            }
            return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },

        async descargar_graficas() {

            var pdf = new jsPDF('l', 'pt');
            const el = this.$refs.graficas_area;

            const options = {
                type: 'dataURL'
            }
            var url = await this.$html2canvas(el, options);

            pdf.setFontSize(20);
            pdf.addImage(url, 'PNG', 20, 80, 800, 320);
            pdf.text(30, 70, 'IMPORTACIONES Y EXPORTACIONES POR MES')
            pdf.save('graficas.pdf');

        },
        async detallesGraficas(tipo) {

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let a = 0;
            if (tipo == 'Importaciones')
                a = this.a1;
            else
                a = this.a2;
            this.titulo_detalle = tipo + " - " + a;
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "anio": a
            };
            await axios.post(this.$hostname + 'reportes/detalle_operaciones_mes/', datos)
                .then((response) => {
                    this.data_tableG = response.data;
                    this.data_tableG = this.data_tableG.filter(t => t.tipo_operacion === tipo);
                    this.data_tableG = this.data_tableG.sort(function (a, b) {
                        return a.mes - b.mes;
                    });

                })
                .catch((error) => {
                    this.data_tableD = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
            if (this.data_tableG.length > 0) {
                document.body.scrollTop = document.body.scrollHeight;
            }

        },
    }
};
</script>

<style scoped>
.footer-hide>>>.VuePagination {
    display: none;
}
</style>
